<template>
  <div class="monitor container is-fluid">
    <div class="columns">
      <div class="column is-12">
        <h4 class="is-size-4-desktop">Disponibilidad de usuarios</h4>
        <h4 class="is-size-6-desktop">
          Sucursal: {{ bodega.sucursal.nombre }} / {{ bodega.nombre }}
        </h4>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <grilla :datos="usuarios" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import Grilla from '@/components/controlUsuarios/Grilla.vue'

export default {
  name: 'ControlUsuarios',
  components: {
    Grilla
  },
  data() {
    return {
      intervalo: null
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    ...mapState('disponibilidad', ['usuarios'])
  },
  mounted() {
    const self = this
    this.$nextTick(() => this.getUsuarios())
    this.intervalo = setInterval(() => {
      self.getUsuarios()
    }, 60000)
  },
  beforeDestroy() {
    clearInterval(this.intervalo)
  },
  methods: {
    getUsuarios() {
      this.$store
        .dispatch('disponibilidad/updateUsuarios')
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>
